import React, {useEffect, useState} from "react";
import useQuizStyles from '../../styles/kozelDarkQuiz/quiz';
import {Box, Typography, Radio, RadioGroup, FormControlLabel, FormControl, Button} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import produs1 from '../../assets/images/kozel_dark_quiz/produs1.png';
import produs2 from '../../assets/images/kozel_dark_quiz/produs2.png';
import mag1 from '../../assets/images/kozel_dark_quiz/mag1.jpg';
import mag2 from '../../assets/images/kozel_dark_quiz/mag2.jpg';
import mag3 from '../../assets/images/kozel_dark_quiz/mag3.jpg';
import mag4 from '../../assets/images/kozel_dark_quiz/mag4.jpg';
import Popup from './Popup';
interface Question {
    id: number;
    text: string;
    options: string[];
}

const personalityTypes = {
    "HONEY_CRUST": {
        type: "HONEY CRUST",
        description: "Ai mereu chef de ceva nou, te arunci cu zâmbetul înainte și îți place când viața are puțină glazură pe margine.",
        ritual: "cel care face prima impresie memorabilă"
    },
    "KOZEL_MIX": {
        type: "KOZEL MIX",
        description: "Ești echilibrul într-un pahar. Ai gust, ai calm, ai prezență. Îți place când lucrurile sunt bine dozate, inclusiv distracția.",
        ritual: "mixul care n-are nevoie de explicații"
    },
    "CINNAMON_ART": {
        type: "CINNAMON ART",
        description: "Ești calm, dar când zici ceva, lumea ascultă. Ai simțul detaliului și un stil care spune mai mult decât cuvintele.",
        ritual: "cel care face diferența fără să ridice tonul"
    }
};

// Mapare răspunsuri la tipuri de personalitate
const answerToPersonality: {[key: string]: string} = {
    // Honey Crust answers
    "Ceva nou, desigur.": "HONEY_CRUST",
    "Cel cu ideile ciudate care uneori sunt geniale.": "HONEY_CRUST",
    "Cu glazură pe margine și ambiții de cocktail.": "HONEY_CRUST",
    
    // Kozel Mix answers
    "Jumate confort, jumate statement.": "KOZEL_MIX",
    "Cel care le echilibrează pe toate.": "KOZEL_MIX",
    "Jumate plin, jumate altceva.": "KOZEL_MIX",
    
    // Cinnamon Art answers
    "Simplu, dar cu un detaliu care face toți banii.": "CINNAMON_ART",
    "Cel care nu zice multe, dar are cele mai bune replici.": "CINNAMON_ART",
    "Simplu la prima vedere. Complex după degustare.": "CINNAMON_ART"
};

const questions: Question[] = [
    {
        id: 1,
        text: "Mergi la un party. Cu ce te îmbraci?",
        options: [
            "Jumate confort, jumate statement.",
            "Ceva nou, desigur.",
            "Simplu, dar cu un detaliu care face toți banii."
        ]
    },
    {
        id: 2,
        text: "Ce ai fi într-un grup de prieteni?",
        options: [
            "Cel cu ideile ciudate care uneori sunt geniale.",
            "Cel care le echilibrează pe toate.",
            "Cel care nu zice multe, dar are cele mai bune replici."
        ]
    },
    {
        id: 3,
        text: "Ce fel de pahar ești la o petrecere?",
        options: [
            "Cu glazură pe margine și ambiții de cocktail.",
            "Jumate plin, jumate altceva.",
            "Simplu la prima vedere. Complex după degustare."
        ]
    }
];

const Quiz: React.FC = () => {
    const classes = useQuizStyles();
    const [currentQuestion, setCurrentQuestion] = useState<number>(0);
    const [answers, setAnswers] = useState<{[key: number]: string}>({});
    const [selectedAnswer, setSelectedAnswer] = useState<string>('');
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [personalityType, setPersonalityType] = useState<any>(null);

    const handleAnswerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedAnswer(event.target.value);
    };

    const calculatePersonalityType = (allAnswers: {[key: number]: string}) => {
        const scores = {
            HONEY_CRUST: 0,
            KOZEL_MIX: 0,
            CINNAMON_ART: 0
        };

        // Calculează scorul pentru fiecare tip de personalitate
        Object.values(allAnswers).forEach(answer => {
            const personalityKey = answerToPersonality[answer];
            if (personalityKey && scores.hasOwnProperty(personalityKey)) {
                scores[personalityKey as keyof typeof scores]++;
            }
        });

        // Găsește scorul maxim
        const maxScore = Math.max(...Object.values(scores));
        const winnersCount = Object.values(scores).filter(score => score === maxScore).length;

        // Dacă avem egalitate la toate (1-1-1), returnează Cinnamon Art
        if (winnersCount === 3 && maxScore === 1) {
            return personalityTypes.CINNAMON_ART;
        }

        // Găsește primul tip cu scorul maxim
        const winnerKey = Object.keys(scores).find(key => scores[key as keyof typeof scores] === maxScore);
        
        return personalityTypes[winnerKey as keyof typeof personalityTypes] || personalityTypes.CINNAMON_ART;
    };

    const handleNextQuestion = () => {
        // Save current answer
        const updatedAnswers = {
            ...answers,
            [currentQuestion]: selectedAnswer
        };
        
        setAnswers(updatedAnswers);

        if (currentQuestion < questions.length - 1) {
            setCurrentQuestion(prev => prev + 1);
            setSelectedAnswer('');
        } else {
            // Quiz completed - calculate personality based on all answers
            const personality = calculatePersonalityType(updatedAnswers);
            setPersonalityType(personality);
            
            setShowPopup(true);
        }
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    const isQuestionCompleted = (questionIndex: number) => {
        return answers[questionIndex] !== undefined;
    };

    const isCurrentQuestionAnswered = selectedAnswer !== '';

    return (
        <>
        <Box className={classes.quizContainer}>
            <Box className={classes.quizContent}>
                {/* Title */}
                <Box className={classes.titleSection}>
                    <Typography variant="h2" className={classes.quizTitle}>
                        RĂSPUNDE ȚAPĂN ȘI POȚI CÂȘTIGA VOUCHER
                    </Typography>
                    <Typography variant="h2" className={classes.quizTitle}>
                        <span className={classes.goldText}>20% DISCOUNT</span> LA PRODUSELE KOZEL!
                    </Typography>
                    <Typography variant="body1" className={classes.subtitle}>
                        Completează quiz-ul de mai jos și vezi ce tipologie țapănă ai.
                    </Typography>
                </Box>

                {/* Current Question Indicator */}
                <Box className={classes.questionIndicator}>
                    <Box className={classes.indicatorCircle}>
                        {currentQuestion + 1}
                    </Box>
                </Box>

                {/* Question */}
                <Box className={classes.questionContainer}>
                    <Typography variant="h4" className={classes.questionText}>
                        {questions[currentQuestion].text}
                    </Typography>

                    <FormControl component="fieldset" className={classes.optionsContainer}>
                        <RadioGroup
                            value={selectedAnswer}
                            onChange={handleAnswerChange}
                            className={classes.radioGroup}
                        >
                            {questions[currentQuestion].options.map((option, index) => (
                                <FormControlLabel
                                    key={index}
                                    value={option}
                                    control={
                                        <Radio 
                                            className={classes.radioButton}
                                            sx={{
                                                color: '#D1A85E',
                                                '&.Mui-checked': {
                                                    color: '#D1A85E',
                                                },
                                            }}
                                        />
                                    }
                                    label={option}
                                    className={classes.optionLabel}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>

                    {isCurrentQuestionAnswered && (
                        <Button
                            onClick={handleNextQuestion}
                            className={classes.nextButton}
                            variant="contained"
                        >
                            {currentQuestion < questions.length - 1 ? 'Următoarea întrebare' : 'Finalizează quiz-ul'}
                        </Button>
                    )}
                </Box>

                {/* Progress Indicators */}
                <Box className={classes.progressContainer}>
                    {questions.map((_, index) => (
                        <Box
                            key={index}
                            className={`${classes.progressCircle} ${
                                isQuestionCompleted(index) ? classes.progressCompleted : ''
                            } ${index === currentQuestion ? classes.progressCurrent : ''}`}
                        >
                            {isQuestionCompleted(index) ? (
                                <CheckIcon className={classes.checkIcon} />
                            ) : (
                                index + 1
                            )}
                        </Box>
                    ))}
                </Box>

                <Box className={classes.dottedLine}></Box>

                <Box className={classes.titleSection}>
                    <Typography variant="h2" className={classes.quizTitle}>
                        DESCOPERĂ PACHETUL SPECIAL
                    </Typography>
                    <Typography variant="h2" className={classes.quizTitle}>
                        <span className={classes.goldText}>KOZEL CINNAMON ART</span> !
                    </Typography>
                </Box>
                    {/* Products Section */}
                <Box className={classes.productsContainer}>
                    <img 
                        src={produs1} 
                        alt="Kozel Product 1" 
                        className={classes.productImage}
                    />
                    <img 
                        src={produs2} 
                        alt="Kozel Product 2" 
                        className={classes.productImage}
                    />
                </Box>

                <Typography variant="body1" className={classes.subtitle}>
                    Disponibil in magazinele
                </Typography>

                {/* Stores Section */}
                <Box className={classes.storesContainer}>
                    <img 
                        src={mag1} 
                        alt="Magazin 1" 
                        className={classes.storeImage}
                    />
                    <img 
                        src={mag2} 
                        alt="Magazin 2" 
                        className={classes.storeImage}
                    />
                    <img 
                        src={mag3} 
                        alt="Magazin 3" 
                        className={classes.storeImage}
                    />
                    <img 
                        src={mag4} 
                        alt="Magazin 4" 
                        className={classes.storeImage}
                    />
                </Box>
            </Box>
        </Box>

         {/* Popup Component */}
            <Popup 
                open={showPopup} 
                onClose={handleClosePopup} 
                personalityType={personalityType}
            />
        </>
    );
};

export default Quiz;